import { RegisterForm } from "@/components/auth/RegisterForm";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

const Register = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  // Removed automatic session check to allow users to access registration page

  return (
    <div className="public-page min-h-screen bg-muted/40 flex flex-col items-center justify-center gap-6 p-4">
      <a href="/" aria-label="Sokoby — Accueil"><img src="/sokoby-official-logo.png" alt="Sokoby" width={614} height={251} className="sokoby-public-logo" /></a>
      <div className="w-full max-w-md">
        <RegisterForm />
      </div>
    </div>
  );
};

export default Register;